import { render, staticRenderFns } from "./lookPre.vue?vue&type=template&id=42f919e0&scoped=true"
import script from "./lookPre.vue?vue&type=script&lang=js"
export * from "./lookPre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f919e0",
  null
  
)

export default component.exports